import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FilterPanel } from '@gsa/afp-component-library';
import { useStandards } from './standards-provider';

const {
  FilterPanelField,
  FilterPanelFilterShape,
} = FilterPanel;

const VehicleTypeFilterItem = ({ filter }) => {
  const [options, setOptions] = useState([{ label: 'Select vehicle type', value: '' }]);
  const prevParentValueRef = useRef(null);
  const { clearOneFilter, setFilters, getFilterFromState } = FilterPanel.useFilterPanel();
  const {
    multipleOptions,
  } = useStandards();

  const vehicleGroupFilter = getFilterFromState('vehicleGroup');
  const fedStandardCodeFilter = getFilterFromState('fedStandardCode');

  useEffect(() => {
    // Clear this filter when parent value changes (either vehicleGroup or fedStandardCode)
    if (prevParentValueRef.current !== null && prevParentValueRef.current !== vehicleGroupFilter.value) {
      clearOneFilter(filter);
    }
    prevParentValueRef.current = vehicleGroupFilter.value;

    if (!vehicleGroupFilter.value || !multipleOptions?.vehicleType) {
      setOptions([{ label: 'Select vehicle type', value: '' }]);
      return;
    }

    // Filter vehicle types based on selected vehicle group
    const filteredTypes = multipleOptions.vehicleType
      .filter((vType) => vType.parent === vehicleGroupFilter.value)
      .map((vType) => ({
        label: vType.label,
        value: vType.value,
      }));

    const optionsWithDefault = [{ label: 'Select vehicle type', value: '' }, ...filteredTypes];
    setOptions(optionsWithDefault);
    setFilters({
      type: 'updateOptions',
      filter: {
        ...filter,
        options: optionsWithDefault,
      },
    });
  }, [vehicleGroupFilter.value, fedStandardCodeFilter.value, multipleOptions]);

  return (
    <div className="margin-top-3">
      <label htmlFor={filter.key} className="usa-label">
        {filter.title}
      </label>
      <FilterPanelField
        key={[filter.key]}
        filter={{
          ...filter,
          type: 'select',
          options,
        }}
      />
    </div>
  );
};

VehicleTypeFilterItem.propTypes = {
  filter: PropTypes.shape(FilterPanelFilterShape).isRequired,
};

export default VehicleTypeFilterItem;
